import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { startCase } from 'lodash';
import styled from 'styled-components';
import { useSession } from '@cordata/buffet';

import Identity from '~/assets/identity.svg';

const StyledPage = styled.div`
  input {
    background-clip: inherit;
    border-color: white;
  }
`;

const CordataNavBar = ({ routes, location }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthed, current } = useSession();

  const toggle = () => setIsOpen(!isOpen);

  return isAuthed && current && !current.attributes.termsOfUseAcceptanceRequired
    ? (
      <StyledPage>
        <Navbar color="primary" dark expand="md" className="mb-3 sticky-top">
          <NavbarBrand tag={Link} to="/home">
            <img src={Identity} width={130} alt="Cordata" className="mr-2" />
          </NavbarBrand>

          <NavbarToggler onClick={toggle} />

          <Collapse isOpen={isOpen} navbar>
            <Nav className="mr-auto" navbar>
              {routes.map(r => (
                <NavItem key={r.path} active={location.pathname.includes(r.path)}>
                  <Link to={r.path} className="nav-link">
                    <FontAwesomeIcon icon={r.icon} fixedWidth size="lg" />
                    <span className="d-inline-block d-sm-inline-block d-md-none ml-2">{startCase(r.label)}</span>
                  </Link>
                </NavItem>
              ))}

            </Nav>

            <Nav className="ml-auto" navbar>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  <FontAwesomeIcon icon="user-circle" fixedWidth size="lg" />
                  <span className="d-inline-block d-sm-inline-block d-md-none ml-2">Options</span>
                </DropdownToggle>

                <DropdownMenu right>
                  <DropdownItem header>
                    User
                  </DropdownItem>

                  <DropdownItem tag={NavLink} to="/user/change-password">
                    <FontAwesomeIcon icon="unlock-alt" className="mr-2" />
                    Change Password
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <NavItem>
                <Link to="/logout" className="nav-link">
                  <FontAwesomeIcon icon="sign-out-alt" fixedWidth size="lg" />
                  <span className="d-inline-block d-sm-inline-block d-md-none ml-2">Logout</span>

                </Link>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </StyledPage>
    ) : <div />;
};

CordataNavBar.propTypes = {
  location: PropTypes.shape().isRequired,
  routes: PropTypes.PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CordataNavBar;
